import axios from "axios";
import {db_url, url_product, url_product_status} from "../url";

export const picture_upload = db_url + '/image'
// export const picture_upload = 'http://127.0.0.1:3002/api_web/v1' + '/image'

export default function DB_Product (token) {
    const product = '/dictionary/product/'

    const formData = new FormData;
    formData.append('token', token);

    const appendToken = (data) => {
        const fd = new FormData;
        for (const pair of data.entries()) {
            fd.append(pair[0], pair[1]);
        }
        fd.append('token', token);
        return fd
    }


    const getProducts = (search, controller ) => {
        return axios.get(db_url + `/dictionary/products?${search}`, {
            signal: controller.signal,
            headers: {
                Authorization: token
            }
        })
    }


    const getProduct = (product_id) => {
        // return axios.post(url_product + product_id, formData)
        return axios.post( db_url + product + `/${product_id}`, formData)
        // return axios.post( 'http://127.0.0.1:3002/api_web/v1' + product + `/${product_id}`, formData)
    }

    const createProduct = (data) => {
        return axios.post(url_product, appendToken(data))
    }


    const updateProduct = (data) => {
        return axios.put(db_url + product, appendToken(data))
        // return axios.put('http://127.0.0.1:3002/api_web/v1' + product, appendToken(data))
    }


    const statusProduct = (data) => {
        return axios.post(url_product_status, appendToken(data))
    }


    return {
        getProducts,
        getProduct,
        createProduct,
        updateProduct,
        statusProduct
    }
}




